import { baseSplitApi as api } from "./baseApi";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createLecturer: build.mutation<
      CreateLecturerApiResponse,
      CreateLecturerApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/bo/lecturers`,
        method: "POST",
        body: queryArg.lecturerUpdateRequest,
      }),
    }),
    getBackOfficeGetLecturer: build.query<
      GetBackOfficeGetLecturerApiResponse,
      GetBackOfficeGetLecturerApiArg
    >({
      query: (queryArg) => ({ url: `/v1/bo/lecturers/${queryArg.id}` }),
    }),
    updateLecturerById: build.mutation<
      UpdateLecturerByIdApiResponse,
      UpdateLecturerByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/bo/lecturers/${queryArg.id}`,
        method: "PUT",
        body: queryArg.lecturerUpdateRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bigsystherApi };
export type CreateLecturerApiResponse = /** status 200 OK */ SuccessResponse201;
export type CreateLecturerApiArg = {
  /** Lecturer update */
  lecturerUpdateRequest: LecturerUpdateRequest;
};
export type GetBackOfficeGetLecturerApiResponse =
  /** status 200 OK */ EntityLecturer;
export type GetBackOfficeGetLecturerApiArg = {
  /** uuid */
  id: string;
};
export type UpdateLecturerByIdApiResponse =
  /** status 200 OK */ SuccessResponse200;
export type UpdateLecturerByIdApiArg = {
  /** uuid */
  id: string;
  /** User update */
  lecturerUpdateRequest: LecturerUpdateRequest;
};
export type SuccessResponse201 = {
  id?: string;
};
export type ValidationError = {
  field?: string;
  message?: string;
};
export type ErrorResponse400 = {
  code?: number;
  data?: ValidationError[];
  message?: string;
};
export type ErrorResponse404 = {
  code?: number;
  data?: {
    [key: string]: string;
  }[];
  message?: string;
};
export type LecturerUpdateRequestTranslation = {
  description: string;
  language: string;
};
export type LecturerUpdateRequest = {
  contactEmail: string;
  fullName: string;
  lecturerImageID?: string;
  translations: LecturerUpdateRequestTranslation[];
};
export type CookieResponse = {
  domain?: string;
  httpOnly?: boolean;
  maxAge?: number;
  name?: string;
  path?: string;
  secure?: boolean;
  value?: string;
};
export type AudioResponse = {
  cookies?: CookieResponse[];
  url?: string;
};
export type AudioMediaResponse = {
  content?: AudioResponse;
  id?: string;
};
export type ImageResponse = {
  type?: string;
  url?: string;
};
export type ImageMediaResponse = {
  content?: ImageResponse[];
  id?: string;
};
export type EntityMediaType = "image" | "video" | "audio";
export type VideoResponse = {
  cookies?: CookieResponse[];
  thumbnail?: ImageResponse[];
  url?: string;
};
export type VideoMediaResponse = {
  content?: VideoResponse;
  id?: string;
};
export type EntityMedia = {
  audio?: AudioMediaResponse;
  createdAt?: string;
  id?: string;
  image?: ImageMediaResponse;
  key?: string;
  type?: EntityMediaType;
  updatedAt?: string;
  video?: VideoMediaResponse;
};
export type EntityLanguage = "en" | "de" | "de";
export type EntityLecturerTranslation = {
  description?: string;
  id?: string;
  language?: EntityLanguage;
};
export type EntityLecturer = {
  contactEmail?: string;
  createdAt?: string;
  fullName?: string;
  id?: string;
  lecturerImage?: EntityMedia;
  translations?: EntityLecturerTranslation[];
  updatedAt?: string;
};
export type SuccessResponse200 = {
  status?: string;
};
export const {
  useCreateLecturerMutation,
  useGetBackOfficeGetLecturerQuery,
  useUpdateLecturerByIdMutation,
} = injectedRtkApi;
